import _regeneratorRuntime from "/Users/haakseth/Workspace/Septima/plandk2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/haakseth/Workspace/Septima/plandk2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { Class } from '../utils';
import icons from '../resources/icons';
import Searcher from './Searcher';
/**
 *
 * @class Enables a client to add a custom searcher to Septima Search
 * @extends Septima.Search.Searcher
 * @constructs Septima.Search.ClientSearcher
 * @param {Object} options ClientSearcher expects these properties:
 * @param options.singular {string} The singular form of the object type returned by the searcher, eg "Photo"
 * @param options.plural {string} The plural form of the object type returned by the searcher, eg "Photos"
 * @param options.isAsync {boolean} Does provider.query() return a thenable or a direct object?
 * @param options.provider {Object|string} searcher The provider or the global name of the provider object (provider = window[provider]) Must implement query(query, limit)
 *
 * @example
 *  //Create a provider
 *       var dummyProvider = {
 *                "query": function(query, limit){
 *                    var results = [];
 *                    for (var i = 0;i<limit;i++){
 *                        results.push({
 *                            title: "title " + i,
 *                            description: "description " + i,
 *                            geometry: null
 *                        });
 *                    }
 *                    var result = {status: "ok", hits: 9999, results: results};
 *                    return result;
 *                },
 *                // The select method is optional. The controller will NOT emit SELECT in SS if defined 
 *                "select": function(result){
 *                  //Do something with result
 *                }
 *       };
 *
 * // Create a clientSearcher
 *        var dummySearcher = new Septima.Search.ClientSearcher({
 *            singular: "objekt",
 *            plural: "objekter",
 *            isAsync: false,
 *            provider: dummyProvider
 *       });
 *
 * // Add the searcher to septima search
 * controller.addSearcher("titleOfSearcher", dummySearcher);
 * // Or
 * connection.addSearcher("titleOfSearcher", dummySearcher);
 *
 *
 */

export default Class(Searcher,
/** @lends Septima.Search.ClientSearcher# */
{
  initialize: function initialize(options) {
    //Options:
    //  {
    //      [source: "nameOfSource",]
    //      singular: "objekt",
    //      plural: "objekter",
    //      isAsync: false,
    //      provider: provider
    //  }
    if (typeof options.provider === 'string') this.provider = window[options.provider];else this.provider = options.provider;
    if (!options.source) options.source = options.plural;
    this.source = options.source; //  provider.query(query, limit) must return
    //  {
    //    status: "ok|error",
    //    hits: nnn,
    //    results: results
    //  }, where
    //  results is an array of
    //  {
    //    title: "title ",
    //    description: "description",
    //    geometry: null|geojsonobject
    //  } 

    this.isAsync = options.isAsync;
    this.singular = options.singular;
    this.plural = options.plural;
    if (options.iconURI) this.iconURI = options.iconURI;else this.iconURI = icons.result.defaultIcon;
    this.Searcher(options);
    this.registerType(this.source, {
      id: this.singular,
      singular: this.singular,
      plural: this.plural
    });
  },
  fetchData: function () {
    var _fetchData = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(query, caller) {
      var _this = this;

      var providerResult;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!this.isAsync) {
                _context.next = 13;
                break;
              }

              _context.prev = 1;
              _context.next = 4;
              return this.provider.query(query.queryString, query.limit + 2);

            case 4:
              providerResult = _context.sent;
              caller.fetchSuccess(this.formatResult(query, providerResult));
              _context.next = 11;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);
              caller.fetchError(this, _context.t0);

            case 11:
              _context.next = 14;
              break;

            case 13:
              setTimeout(function () {
                try {
                  var _providerResult = _this.provider.query(query.queryString, query.limit + 2);

                  caller.fetchSuccess(_this.formatResult(query, _providerResult));
                } catch (error) {
                  caller.fetchError(_this, error);
                }
              }, 100);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[1, 8]]);
    }));

    function fetchData(_x, _x2) {
      return _fetchData.apply(this, arguments);
    }

    return fetchData;
  }(),
  formatResult: function formatResult(query, providerResultArg) {
    var providerResult = null;
    if (typeof providerResultArg === 'string') providerResult = JSON.parse(providerResultArg);else providerResult = providerResultArg;
    var results = null;
    var totalMatchCount = null;
    var queryResult = this.createQueryResult();

    if (Array.isArray(providerResult)) {
      //Old style, only results returned
      results = providerResult;
    } else if (providerResult.status.toLowerCase() === "ok") {
      if (typeof providerResult.hits !== 'undefined') totalMatchCount = providerResult.hits;
      results = providerResult.results;
    } else {
      return queryResult;
    }

    var count = results.length;

    if (["list", "cut", "no-cut"].indexOf(query.type) !== -1) {
      var hitsShown = count === 1 ? 1 : query.type === 'no-cut' && count > query.limit ? 0 : Math.min(count, query.limit);
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = results.slice(0, hitsShown)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var hit = _step.value;
          this.addResultFromHit(query, queryResult, hit);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (count > hitsShown && ["no-cut", "cut"].indexOf(query.type) !== -1) {
        var title = this.plural;
        if (totalMatchCount != null) title = title + " (" + totalMatchCount + ")";
        queryResult.addNewQuery(this.source, this.singular, title + "", null, query.queryString, null, null);
      }
    } else if (count > 0) {
      var title2 = this.plural + "";
      if (totalMatchCount != null) title2 = title2 + " (" + totalMatchCount + ")";
      queryResult.addNewQuery(this.source, this.singular, title2, null, query.queryString, null, null);
    }

    return queryResult;
  },
  addResultFromHit: function addResultFromHit(query, queryResult, hit) {
    var displayname = hit.title;
    if (!query.hasTarget) displayname += " (" + this.singular + ")";
    var description = null;
    if (hit.description) description = hit.description;
    var geometry = null;
    if (hit.geometry) geometry = hit.geometry;
    var result = queryResult.addResult(this.source, this.singular, displayname, description, geometry, hit);
    if (typeof hit.id !== 'undefined') result.id = hit.id;
  },
  onSelect: function onSelect(result) {
    if (!result.isNewQuery()) {
      if (typeof this.provider.select !== 'undefined') try {
        return this.provider.select(result.data);
      } catch (e) {// catch-all
      }

      this._onSelectCallback(result);
    }
  },
  resultFromHit: function resultFromHit(hit) {
    var queryResult = this.createQueryResult();
    var displayname = hit.title;
    var description = null;
    if (hit.description) description = hit.description;
    var geometry = null;
    if (hit.geometry) geometry = hit.geometry;
    var result = queryResult.addResult(this.source, this.singular, displayname, description, geometry, hit);
    if (typeof hit.id !== 'undefined') result.id = hit.id;
    return result;
  },
  get: function () {
    var _get = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2(id) {
      var hit, _hit;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(typeof this.provider.get !== 'undefined')) {
                _context2.next = 12;
                break;
              }

              if (!this.isAsync) {
                _context2.next = 8;
                break;
              }

              _context2.next = 4;
              return this.provider.get(id);

            case 4:
              hit = _context2.sent;
              return _context2.abrupt("return", this.resultFromHit(hit));

            case 8:
              _hit = this.provider.get(id);
              return _context2.abrupt("return", this.resultFromHit(_hit));

            case 10:
              _context2.next = 13;
              break;

            case 12:
              throw new Error('Whoops! get(id) is not implemented in ' + this.singular + ' searcher');

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function get(_x3) {
      return _get.apply(this, arguments);
    }

    return get;
  }(),
  CLASS_NAME: 'Septima.Search.ClientSearcher'
});